import { render, staticRenderFns } from "./ValveCardHeader.vue?vue&type=template&id=7d4c5620&"
import script from "./ValveCardHeader.vue?vue&type=script&lang=js&"
export * from "./ValveCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports